// extracted by mini-css-extract-plugin
module.exports = {"icon":"FloatingChatTrigger__icon___3DqTr","sm":"FloatingChatTrigger__sm___1L4S6","md":"FloatingChatTrigger__md___7nZoR"};